import { network } from 'services/network';

import { QueryParams } from 'api/mutations/downloadExternalDocument.mutation';

export const downloadCardAssociatedDocument = async (params: QueryParams) => {
    const urlPath = `api/bo/downloadCardAssociatedDocument?docId=${params.documentId}`;
    const previewWindow = window.open('', '_blank');

    const response = await network.post(urlPath, null, {
        transformRequest: [
            (data) => {
                return data;
            },
        ],
        responseType: 'blob',
    });

    const mimeType = (response.headers['content-type'] ?? '').toLowerCase();
    const fileName = params.fileName.toLowerCase();
    const isPdf = mimeType.includes('application/pdf') || fileName.endsWith('.pdf');
    const isImage = mimeType.startsWith('image/') || /\.(png|jpe?g|gif|bmp|webp|svg)$/.test(fileName);
    const previewMimeType = isPdf ? 'application/pdf' : isImage ? 'image/*' : mimeType || 'application/octet-stream';

    const blob = new Blob([response.data], {
        type: previewMimeType,
    });

    const url = window.URL.createObjectURL(blob);
    if (isPdf || isImage) {
        if (previewWindow) {
            if (isPdf) {
                previewWindow.document.write(`
                  <!doctype html><title>${params.fileName}</title>
                  <style>html,body{margin:0;height:100%;background:#111}iframe{border:0;width:100%;height:100%}</style>
                  <iframe src="${url}" title="${params.fileName}"></iframe>
                `);
            } else {
                previewWindow.document.write(`
                  <!doctype html><title>${params.fileName}</title>
                  <style>html,body{margin:0;background:#111;display:grid;place-items:center;height:100vh}img{max-width:100%;max-height:100%}</style>
                  <img src="${url}" alt="${params.fileName}" />
                `);
            }
        } else {
            window.open(url, '_blank');
        }
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        return;
    }

    if (previewWindow) {
        previewWindow.close();
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = params.fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};
